module.exports = __webpack_public_path__ + "media/images/about1-a80f7f697784ce38e19d4994ee8eddb4.png";